import Button from './Button.tsx';
import { isUserLoggedIn, logIn } from '../utils/auth.ts';
import { ADVANTAGE_APP_LINK } from '../constants/config.ts';

const AdvantageCouponButton = ({
  hasCode,
  isCouponSaving,
  onSave
}: {
  hasCode: string | undefined;
  isCouponSaving: boolean;
  onSave: () => void;
}) => {
  if (hasCode) {
    return;
  }
  if (isCouponSaving) {
    return <span className="fs-20 offer-overlay-content__coupon__code--copied me-4 ms-4">Kupon sačuvan</span>;
  }

  return (
    <div className="offer-overlay-content__coupon__advantage-button">
      <Button className="mb-3" onClick={onSave}>
        <span className="d-block pt-2 pb-2 ps-3 pe-3">Sačuvaj kupon</span>
      </Button>
    </div>
  );
};

const AdvantageCta = () => {
  const handleRedirect = () => {
    window.open(ADVANTAGE_APP_LINK, '_blank');
  };

  return (
    <div
      className="offer-overlay-content__coupon__advantage-cta cursor-pointer font-yettel-bold"
      onClick={() => (!isUserLoggedIn() ? logIn() : handleRedirect())}
    >
      Preuzmi uz
      <br /> Y. Sve mobile+bank
    </div>
  );
};

const StandardCouponButton = ({ isCouponSaving, onSave }: { isCouponSaving: boolean; onSave: () => void }) => {
  if (isCouponSaving) {
    return <span className="fs-20 offer-overlay-content__coupon__code--copied me-4 ms-4">Kupon sačuvan</span>;
  }

  return (
    <Button className="mb-3" onClick={onSave}>
      <span className="d-block pt-2 pb-2 ps-3 pe-3">Sačuvaj kupon</span>
    </Button>
  );
};

export const OfferOverlaySaveButton = ({
  isOfferAdvantage,
  isUserAdvantage,
  isCouponActive,
  isCouponSaving,
  offer,
  handleSaveOfferClick
}: {
  isOfferAdvantage: boolean;
  isUserAdvantage: boolean;
  isCouponActive: boolean;
  isCouponSaving: boolean;
  offer: { code?: string };
  handleSaveOfferClick: () => void;
}) => {
  if (isOfferAdvantage) {
    if (isUserAdvantage) {
      if (!isCouponActive) return null;
      return (
        <AdvantageCouponButton hasCode={offer.code} isCouponSaving={isCouponSaving} onSave={handleSaveOfferClick} />
      );
    } else {
      return <AdvantageCta />;
    }
  }

  if (!offer.code && isCouponActive) {
    return <StandardCouponButton isCouponSaving={isCouponSaving} onSave={handleSaveOfferClick} />;
  }

  return null;
};
